import script from "./auth-status-individual.vue?vue&type=script&lang=tsx&setup=true"
export * from "./auth-status-individual.vue?vue&type=script&lang=tsx&setup=true"

import "./auth-status-individual.vue?vue&type=style&index=0&id=53600a26&lang=scss"

const __exports__ = script;

export default __exports__